var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiWellPlungerLift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 854,
    height: 790,
    viewBox: "0 0 854 790",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3058_90418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.264 520.602H853.393V642.779L780.204 594.404L673.861 639.677L566.264 594.403L473.058 680.61L372.342 709.14L327.928 672.548L292.897 619.831L259.742 651.462L185.926 590.062L134.63 597.505L77.08 548.509L2.63965 529.904L3.264 520.602Z",
    fill: "#384252",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.26384 520.602V521.203H852.787V641.655L780.267 593.722L673.859 639.023L566.139 593.697L472.75 680.071L372.483 708.474L328.385 672.142L293.001 618.896L259.714 650.653L186.108 589.428L134.816 596.869L77.3663 547.961L3.27796 529.443L3.86903 520.642L3.26384 520.602V521.203V520.602L2.65865 520.562L2 530.364L76.7934 549.058L134.445 598.14L185.745 590.697L259.769 652.27L292.792 620.767L327.47 672.953L372.201 709.805L473.364 681.148L566.39 595.109L673.861 640.331L780.141 595.085L854 643.903V520H2.69597L2.65865 520.562L3.26384 520.602Z",
    fill: "#384252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.26384 520.602V521.203H852.787V641.655L780.267 593.722L673.859 639.023L566.139 593.697L472.75 680.071L372.483 708.474L328.385 672.142L293.001 618.896L259.714 650.653L186.108 589.428L134.816 596.869L77.3663 547.961L3.27796 529.443L3.86903 520.642L3.26384 520.602ZM3.26384 520.602V521.203V520.602ZM3.26384 520.602L2.65865 520.562L2 530.364L76.7934 549.058L134.445 598.14L185.745 590.697L259.769 652.27L292.792 620.767L327.47 672.953L372.201 709.805L473.364 681.148L566.39 595.109L673.861 640.331L780.141 595.085L854 643.903V520H2.69597L2.65865 520.562L3.26384 520.602Z",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3058_90418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.91 501.53H125.91V511.53H200.91V501.53Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.71 509.53H121.71V518.53H204.71V509.53Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.03 458.7H43.6504V472.43H487.03V458.7Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.02 195.55H127.02V200.36H199.02V195.55Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.97 137.29H159.94V343.85H168.97V137.29Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.97 128H159.94V343.86H168.97V128Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.82 307.44L732.47 295.03L179.79 294.85L179.69 307.69L716.82 307.44Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.02 307.44V295.03L179.8 294.85L179.69 307.69L779.02 307.44Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.51 292.77H418.04V310.68H431.51V292.77Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.59 288.71H422.1V314.06H427.59V288.71Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.02 291.77H482.91V309.68H521.02V291.77Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.77 284.82H156.22V318.63H172.77V284.82Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.87 293.5L169.01 300.82L172.87 308.89L180.69 309.04L180.84 293.54L172.87 293.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.25 455.77H417.41V474.67H445.25V455.77Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.36 454.07H426.43V476.38H436.36V454.07Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.79 400.24C517.91 428.84 504.79 464.11 493.43 472.81L492.13 474.09C477.64 491.61 452.84 484.75 436.02 476.2",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.81 262.42C267.74 267.11 270.58 293.49 308.9 294.92",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.4 399.74C480.46 417.81 489.4 424.22 498.46 444.48L481.4 399.74Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.4 399.74C480.46 417.81 489.4 424.22 498.46 444.48",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.94 325.63C488.19 316.38 479.36 310.63 467.76 307.47",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.63 318H495.52V514H505.63V318Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.13 509.47H494.01V519.1H507.13V509.47Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.461 457.02H492.98V474.02H502.461V457.02Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.28 453.21H493.59V476H507.28V453.21Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.23 309.38H491.62V318.36H509.23V309.38Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.02 326.15H463.95V400.75H537.02V326.15Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.1 329.2H467.44V397.47H533.1V329.2Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.669 316.39H511.02V324.42H527.669V316.39Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.26 187.04H514.43V316.39H524.26V187.04Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.26 172H514.43V316.39H524.26V172Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.669 163.93H511.02V176.04H527.669V163.93Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.669 163.93H511.02V176.04H527.669V163.93Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.42 169.57H566.69",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.42 169.57H566.69",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.03 146.12V191.36",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.03 146.12V191.36",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.93 151.06V188.32",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.93 151.06V188.32",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.4 154.3V183.87",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.4 154.3V183.87",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.82 160.01V179.95",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.82 160.01V179.95",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.29 163.93V175.4",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.29 163.93V175.4",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.76 165.81V173.33",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.76 165.81V173.33",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.14 456.34H365.17V475.24H387.14V456.34Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.64 454.64H374.6V476.95H388.64V454.64Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.65 452H380.12V480H388.65V452Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.89 455.53H301.58V474.43H335.89V455.53Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.89 455.53H301.58V474.43H335.89V455.53Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.97 448.13V456.86L319.3 460.24L327.6 456.78V448.14L310.97 448.13Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.97 448.13V456.86L319.3 460.24L327.6 456.78V448.14L310.97 448.13Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.74 292.14H696.51V296.45H706.74V292.14Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.39 292.14H713.16V296.45H723.39V292.14Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.94 284.41H698.12V293.34H704.94V284.41Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.94 284.41H698.12V293.34H704.94V284.41Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.79 284.41H714.97V293.14H721.79V284.41Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.79 284.41H714.97V293.14H721.79V284.41Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725 280.4H694.71V286.02H725V280.4Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725 280.4H694.71V286.02H725V280.4Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.39 265.96H696.51V281.41H723.39V265.96Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.39 265.96H696.51V281.41H723.39V265.96Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.46 265.96C721.263 265.96 730.02 257.203 730.02 246.4C730.02 235.597 721.263 226.84 710.46 226.84C699.658 226.84 690.9 235.597 690.9 246.4C690.9 257.203 699.658 265.96 710.46 265.96Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.46 265.96C721.263 265.96 730.02 257.203 730.02 246.4C730.02 235.597 721.263 226.84 710.46 226.84C699.658 226.84 690.9 235.597 690.9 246.4C690.9 257.203 699.658 265.96 710.46 265.96Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.4 228.59C713.933 228.588 717.387 229.634 720.326 231.596C723.265 233.558 725.555 236.347 726.908 239.611C728.261 242.875 728.616 246.467 727.927 249.932C727.238 253.397 725.537 256.581 723.039 259.079C720.54 261.577 717.357 263.279 713.892 263.967C710.426 264.656 706.834 264.302 703.57 262.949C700.307 261.596 697.517 259.305 695.556 256.366C693.594 253.428 692.548 249.973 692.55 246.44C692.552 241.707 694.434 237.168 697.781 233.821C701.128 230.474 705.666 228.593 710.4 228.59Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.4 228.59C713.933 228.588 717.387 229.634 720.326 231.596C723.265 233.558 725.555 236.347 726.908 239.611C728.261 242.875 728.616 246.467 727.927 249.932C727.238 253.397 725.537 256.581 723.039 259.079C720.54 261.577 717.357 263.279 713.892 263.967C710.426 264.656 706.834 264.302 703.57 262.949C700.307 261.596 697.517 259.305 695.556 256.366C693.594 253.428 692.548 249.973 692.55 246.44C692.552 241.707 694.434 237.168 697.781 233.821C701.128 230.474 705.666 228.593 710.4 228.59Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.99 240.08H697.11V252.92H723.99V240.08Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.99 240.08H697.11V252.92H723.99V240.08Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.85 406.65H317.84V433.19H320.85V406.65Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.85 406.65H317.84V433.19H320.85V406.65Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.84 428.32H320.85",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.84 428.32H320.85",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.84 420.72H320.85",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.84 420.72H320.85",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.84 413.07H320.85",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.84 413.07H320.85",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.84 410.94H320.85",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.84 410.94H320.85",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.7 400.63C320.7 403.63 320.09 406.05 319.34 406.05C318.59 406.05 317.99 403.62 317.99 400.63C317.99 397.64 318.6 395.21 319.34 395.21C320.08 395.21 320.7 397.64 320.7 400.63Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.7 400.63C320.7 403.63 320.09 406.05 319.34 406.05C318.59 406.05 317.99 403.62 317.99 400.63C317.99 397.64 318.6 395.21 319.34 395.21C320.08 395.21 320.7 397.64 320.7 400.63Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.84 414.9H312.57V413.67C312.57 413.67 308.28 412.15 307.35 413.07C306.42 413.99 306.2 417.63 307.35 417.69C309.96 417.81 317.84 417.81 317.84 417.81",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.84 414.9H312.57V413.67C312.57 413.67 308.28 412.15 307.35 413.07C306.42 413.99 306.2 417.63 307.35 417.69C309.96 417.81 317.84 417.81 317.84 417.81",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.84 414.9H312.57V413.67C312.57 413.67 308.28 412.15 307.35 413.07C306.42 413.99 306.2 417.63 307.35 417.69C309.96 417.81 317.84 417.81 317.84 417.81",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.84 414.9H312.57V413.67C312.57 413.67 308.28 412.15 307.35 413.07C306.42 413.99 306.2 417.63 307.35 417.69C309.96 417.81 317.84 417.81 317.84 417.81",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.79 414.9V417.81",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.79 414.9V417.81",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.34 395.21C317.84 394.41 325.16 399.49 325.16 406.85C325.16 410.45 320.85 418.7 320.85 420.72",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.37 186.05L258.6 185.82L259.19 184.24H265.41L266.2 185.79L269.21 186.05V285.42H255.37V186.05Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.25 254.72H253.34V264.95H271.25V254.72Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.04 258.03H250.56V261.64H274.04V258.03Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.74 203.31H252.84V228.33H271.74V203.31Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.5 224.13H253.23L256.62 215.81L253.16 207.51H244.52L244.5 224.13Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.43 435.3L316.1 435.27L316.58 433.87H321.72L322.37 435.27L324.86 435.3V448.24H313.43V435.3Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.43 435.3L316.1 435.27L316.58 433.87H321.72L322.37 435.27L324.86 435.3V448.24H313.43V435.3Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.89 291.53H746.58V310.43H780.89V291.53Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755.97 284.13V292.86L764.3 296.24L772.6 292.78V284.14L755.97 284.13Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.85 231.65H762.84V258.19H765.85V231.65Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.84 253.32H765.85",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.84 245.72H765.85",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.84 238.07H765.85",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.7 225.63C765.7 228.63 765.09 231.05 764.34 231.05C763.59 231.05 762.99 228.62 762.99 225.63C762.99 222.64 763.6 220.21 764.34 220.21C765.08 220.21 765.7 222.64 765.7 225.63Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.841 239.9H757.57V238.67C757.57 238.67 753.281 237.15 752.351 238.07C751.421 238.99 751.201 242.63 752.351 242.69C754.961 242.81 762.841 242.81 762.841 242.81",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.841 239.9H757.57V238.67C757.57 238.67 753.281 237.15 752.351 238.07C751.421 238.99 751.201 242.63 752.351 242.69C754.961 242.81 762.841 242.81 762.841 242.81",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.79 239.9V242.81",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M764.34 220.21C762.84 219.41 770.16 224.49 770.16 231.85C770.16 235.45 765.85 243.7 765.85 245.72",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.42 261.38L761.1 261.33L761.58 258.87H766.72L767.37 261.32L769.86 261.38V284H758.42V261.38Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.5 158.07H260.49V184.61H263.5V158.07Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.49 179.74H263.5",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.49 172.15H263.5",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.49 164.49H253.5",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.49 164.49H253.5",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.49 162.37H263.5",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.5 152.05C263.5 155.05 262.89 157.47 262.14 157.47C261.39 157.47 260.78 155.05 260.78 152.05C260.78 149.05 261.39 146.64 262.14 146.64C262.89 146.64 263.5 149.06 263.5 152.05Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.49 166.33H255.22V165.1C255.22 165.1 250.92 163.57 250 164.49C249.08 165.41 248.85 169.06 250 169.11C252.61 169.24 260.49 169.24 260.49 169.24",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.49 166.33H255.22V165.1C255.22 165.1 250.92 163.57 250 164.49C249.08 165.41 248.85 169.06 250 169.11C252.61 169.24 260.49 169.24 260.49 169.24",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.02 146.64C260.52 145.83 267.84 150.91 267.84 158.28C267.84 161.87 263.52 170.12 263.53 172.15",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.66 184.61H156.11V232.72H172.66V184.61Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.66 184.61H156.11V232.72H172.66V184.61Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.77 208.05L167.91 215.37L171.77 223.44L179.59 223.59L179.74 208.09L171.77 208.05Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.77 208.05L167.91 215.37L171.77 223.44L179.59 223.59L179.74 208.09L171.77 208.05Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.5 208.95H179.84V222.68H234.5V208.95Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.02 208.95H179.84V222.68H244.02V208.95Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.09 206.37H199.25V225.27H227.09V206.37Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.13 204.66H208.2V226.97H218.13V204.66Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.09 292.27H199.25V311.17H227.09V292.27Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.13 290.57H208.2V312.88H218.13V290.57Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.27 201.47H211.06V204.48H215.27V201.47Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.27 286.9H211.06V289.91H215.27V286.9Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.27 248.93H156.06V260H158.27V248.93Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.11 201.87H172.02",
    stroke: "#F7F9F9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.28 133.71H169.31",
    stroke: "#F7F9F9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.79 292.99H323.98V309.54H357.79V292.99Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.35 292.62L340.27 296.48L351.21 292.62L351.42 276.86H330.35V292.62Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.41 292.99H244.6V309.54H278.41V292.99Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.73 293.63L261.06 296.48L269.13 293.63L269.28 282H253.73V293.63Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.35 282.28H351.35",
    stroke: "#F7F9F9",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.64 277.41C328.991 272.843 327.049 267.145 327.15 261.3C327.15 248.42 332.64 243.46 332.64 243.46H348.64C348.64 243.46 353.64 249.46 353.64 261.3C353.64 272.19 348.64 277.41 348.64 277.41H332.64Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.64 277.41C328.991 272.843 327.049 267.145 327.15 261.3C327.15 248.42 332.64 243.46 332.64 243.46H348.64C348.64 243.46 353.64 249.46 353.64 261.3C353.64 272.19 348.64 277.41 348.64 277.41H332.64Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.56 216H332.56V243.55H348.56V216Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.02 231.77C319.227 226.681 330.446 223.947 341.85 223.77C352.295 223.81 362.551 226.567 371.61 231.77L371.44 233.53L349.73 237L339.97 237.24L331.97 236.93L309.02 233.47V231.77Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.02 231.77C319.227 226.681 330.446 223.947 341.85 223.77C352.295 223.81 362.551 226.567 371.61 231.77L371.44 233.53L349.73 237L339.97 237.24L331.97 236.93L309.02 233.47V231.77Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.73 272.57C332.231 269.125 330.928 264.956 331.02 260.7C331.02 251.22 334.71 247.57 334.71 247.57H346.24C346.24 247.57 349.61 251.97 349.61 260.7C349.61 268.7 346.24 272.57 346.24 272.57H334.73Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.73 272.57C332.231 269.125 330.928 264.956 331.02 260.7C331.02 251.22 334.71 247.57 334.71 247.57H346.24C346.24 247.57 349.61 251.97 349.61 260.7C349.61 268.7 346.24 272.57 346.24 272.57H334.73Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.33 247.57H337.79V248.48H343.33V247.57Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.66 232.08H309.43V233.55H371.66V232.08Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.66 232.08H309.43V233.55H371.66V232.08Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.61 230.6H309.43V232.07H311.61V230.6Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.46 230.6H345.28V232.07H347.46V230.6Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.27 230.6H339.09V232.07H341.27V230.6Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.08 230.6H332.9V232.07H335.08V230.6Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.74 230.6H327.56V232.07H329.74V230.6Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.53 230.6H322.35V232.07H324.53V230.6Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.07 230.6H316.89V232.07H319.07V230.6Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.74 230.6H366.56V232.07H368.74V230.6Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.28 230.6H357.1V232.07H359.28V230.6Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.01 230.6H351.83V232.07H354.01V230.6Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.31 230.6H362.13V232.07H364.31V230.6Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.02 230.6H369.84V232.07H372.02V230.6Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.71 230.6H312.53V232.07H314.71V230.6Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.93 214.26H337.55V215.24H343.93V214.26Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.76 265.66H338.22V267.95H343.76V265.66Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.28 266.12H336.91V267.49H338.28V266.12Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.41 247.57V266.8",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.41 247.57V266.8",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.31 166.2V169.11",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.47 251H152.03V260.01H153.47V251Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.51 255.19H154.29V259.75H155.51V255.19Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.01 440.43H135.61V501.33H194.01V440.43Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.12 480.94H193.4L190.01 489.26L193.47 497.56H202.11L202.12 480.94Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.61 487.81H228.07V490.82H254.61V487.81Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.94 487.81V490.82",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.53 487.81V490.82",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.19 487.81V490.82",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.62 490.67C257.62 490.67 255.21 490.06 255.21 489.31C255.21 488.56 257.63 487.95 260.62 487.95C263.61 487.95 266.04 488.56 266.04 489.31C266.04 490.06 263.62 490.67 260.62 490.67Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.35 487.81V482.54H247.58C247.58 482.54 249.11 478.24 248.18 477.32C247.25 476.4 243.62 476.17 243.57 477.32C243.44 479.93 243.44 487.81 243.44 487.81",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.35 487.81V482.54H247.58C247.58 482.54 249.11 478.24 248.18 477.32C247.25 476.4 243.62 476.17 243.57 477.32C243.44 479.93 243.44 487.81 243.44 487.81",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.35 484.76H243.44",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.02 489.31C266.83 487.81 261.74 495.13 254.38 495.13C250.79 495.13 242.54 490.81 240.51 490.82",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.87 483.39L224.92 486.06L227.39 486.54V491.68L224.93 492.34L224.87 494.83H202.25V483.39H224.87Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.39 398H144.89V414.03H185.39V398Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.01 445.63H127.01V449.13H133.01V445.63Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.61 445.63H135.61V449.13H141.61V445.63Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.31 445.63H144.31V449.13H150.31V445.63Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.91 445.63H152.91V449.13H158.91V445.63Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.51 445.63H161.51V449.13H167.51V445.63Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.21 445.63H170.21V449.13H176.21V445.63Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.81 445.63H178.81V449.13H184.81V445.63Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.41 445.63H187.41V449.13H193.41V445.63Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.11 445.63H196.11V449.13H202.11V445.63Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.51 410.83H121.71V446.13H207.51V410.83Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.01 407.63H127.01V411.13H133.01V407.63Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.61 407.63H135.61V411.13H141.61V407.63Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.31 407.63H144.31V411.13H150.31V407.63Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.91 407.63H152.91V411.13H158.91V407.63Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.51 407.63H161.51V411.13H167.51V407.63Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.21 407.63H170.21V411.13H176.21V407.63Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.81 407.63H178.81V411.13H184.81V407.63Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.41 407.63H187.41V411.13H193.41V407.63Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.11 407.63H196.11V411.13H202.11V407.63Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.31 440.63C166.574 440.63 168.41 438.794 168.41 436.53C168.41 434.266 166.574 432.43 164.31 432.43C162.046 432.43 160.21 434.266 160.21 436.53C160.21 438.794 162.046 440.63 164.31 440.63Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.71 428.13H207.51H121.71Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.71 428.13H207.51",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.77 342.2H156.22V393.36H172.77V342.2Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.16 391.56H146.44V411.12H183.16V391.56Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.45 387.52C173.105 387.52 180.12 380.504 180.12 371.85C180.12 363.196 173.105 356.18 164.45 356.18C155.796 356.18 148.78 363.196 148.78 371.85C148.78 380.504 155.796 387.52 164.45 387.52Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.45 379.85C168.868 379.85 172.45 376.268 172.45 371.85C172.45 367.432 168.868 363.85 164.45 363.85C160.032 363.85 156.45 367.432 156.45 371.85C156.45 376.268 160.032 379.85 164.45 379.85Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.16 368.46C155.679 368.46 156.91 367.229 156.91 365.71C156.91 364.191 155.679 362.96 154.16 362.96C152.641 362.96 151.41 364.191 151.41 365.71C151.41 367.229 152.641 368.46 154.16 368.46Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.36 363.46C161.879 363.46 163.11 362.229 163.11 360.71C163.11 359.191 161.879 357.96 160.36 357.96C158.842 357.96 157.61 359.191 157.61 360.71C157.61 362.229 158.842 363.46 160.36 363.46Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.36 363.46C169.879 363.46 171.11 362.229 171.11 360.71C171.11 359.191 169.879 357.96 168.36 357.96C166.842 357.96 165.61 359.191 165.61 360.71C165.61 362.229 166.842 363.46 168.36 363.46Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.16 368.46C175.679 368.46 176.91 367.229 176.91 365.71C176.91 364.191 175.679 362.96 174.16 362.96C172.641 362.96 171.41 364.191 171.41 365.71C171.41 367.229 172.641 368.46 174.16 368.46Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.16 375.06C177.679 375.06 178.91 373.829 178.91 372.31C178.91 370.791 177.679 369.56 176.16 369.56C174.641 369.56 173.41 370.791 173.41 372.31C173.41 373.829 174.641 375.06 176.16 375.06Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.66 375.06C154.179 375.06 155.41 373.829 155.41 372.31C155.41 370.791 154.179 369.56 152.66 369.56C151.141 369.56 149.91 370.791 149.91 372.31C149.91 373.829 151.141 375.06 152.66 375.06Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.76 381.71C175.279 381.71 176.51 380.479 176.51 378.96C176.51 377.441 175.279 376.21 173.76 376.21C172.241 376.21 171.01 377.441 171.01 378.96C171.01 380.479 172.241 381.71 173.76 381.71Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.16 381.81C156.679 381.81 157.91 380.579 157.91 379.06C157.91 377.541 156.679 376.31 155.16 376.31C153.641 376.31 152.41 377.541 152.41 379.06C152.41 380.579 153.641 381.81 155.16 381.81Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.16 386.16C169.679 386.16 170.91 384.929 170.91 383.41C170.91 381.891 169.679 380.66 168.16 380.66C166.641 380.66 165.41 381.891 165.41 383.41C165.41 384.929 166.641 386.16 168.16 386.16Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.16 386.16C162.679 386.16 163.91 384.929 163.91 383.41C163.91 381.891 162.679 380.66 161.16 380.66C159.641 380.66 158.41 381.891 158.41 383.41C158.41 384.929 159.641 386.16 161.16 386.16Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.26 416C188.754 416 208.61 396.144 208.61 371.65C208.61 347.156 188.754 327.3 164.26 327.3C139.766 327.3 119.91 347.156 119.91 371.65C119.91 396.144 139.766 416 164.26 416Z",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.11 400.91L163.72 371.59L130.11 400.91Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.11 400.91L163.72 371.59",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.79 370.78L203.2 389.67L162.79 370.78Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.79 370.78L203.2 389.67",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.53 327.3L163.58 371.72L159.53 327.3Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.53 327.3L163.58 371.72",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.76 456.36H68.04V473.89H106.76V456.36Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3996 489.5C100.958 489.5 111.95 478.509 111.95 464.95C111.95 451.391 100.958 440.4 87.3996 440.4C73.841 440.4 62.8496 451.391 62.8496 464.95C62.8496 478.509 73.841 489.5 87.3996 489.5Z",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4005 480.62C96.0548 480.62 103.07 473.604 103.07 464.95C103.07 456.296 96.0548 449.28 87.4005 449.28C78.7462 449.28 71.7305 456.296 71.7305 464.95C71.7305 473.604 78.7462 480.62 87.4005 480.62Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4004 472.95C91.8187 472.95 95.4004 469.368 95.4004 464.95C95.4004 460.532 91.8187 456.95 87.4004 456.95C82.9821 456.95 79.4004 460.532 79.4004 464.95C79.4004 469.368 82.9821 472.95 87.4004 472.95Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0996 461.57C78.6184 461.57 79.8496 460.339 79.8496 458.82C79.8496 457.301 78.6184 456.07 77.0996 456.07C75.5808 456.07 74.3496 457.301 74.3496 458.82C74.3496 460.339 75.5808 461.57 77.0996 461.57Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2998 456.57C84.8186 456.57 86.0498 455.339 86.0498 453.82C86.0498 452.301 84.8186 451.07 83.2998 451.07C81.781 451.07 80.5498 452.301 80.5498 453.82C80.5498 455.339 81.781 456.57 83.2998 456.57Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2998 456.57C92.8186 456.57 94.0498 455.339 94.0498 453.82C94.0498 452.301 92.8186 451.07 91.2998 451.07C89.781 451.07 88.5498 452.301 88.5498 453.82C88.5498 455.339 89.781 456.57 91.2998 456.57Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0996 461.57C98.6184 461.57 99.8496 460.339 99.8496 458.82C99.8496 457.301 98.6184 456.07 97.0996 456.07C95.5808 456.07 94.3496 457.301 94.3496 458.82C94.3496 460.339 95.5808 461.57 97.0996 461.57Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0996 468.16C100.618 468.16 101.85 466.929 101.85 465.41C101.85 463.891 100.618 462.66 99.0996 462.66C97.5808 462.66 96.3496 463.891 96.3496 465.41C96.3496 466.929 97.5808 468.16 99.0996 468.16Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5996 468.16C77.1184 468.16 78.3496 466.929 78.3496 465.41C78.3496 463.891 77.1184 462.66 75.5996 462.66C74.0808 462.66 72.8496 463.891 72.8496 465.41C72.8496 466.929 74.0808 468.16 75.5996 468.16Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7002 474.82C98.219 474.82 99.4502 473.589 99.4502 472.07C99.4502 470.551 98.219 469.32 96.7002 469.32C95.1814 469.32 93.9502 470.551 93.9502 472.07C93.9502 473.589 95.1814 474.82 96.7002 474.82Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0996 474.91C79.6184 474.91 80.8496 473.679 80.8496 472.16C80.8496 470.641 79.6184 469.41 78.0996 469.41C76.5808 469.41 75.3496 470.641 75.3496 472.16C75.3496 473.679 76.5808 474.91 78.0996 474.91Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0996 479.26C92.6184 479.26 93.8496 478.029 93.8496 476.51C93.8496 474.991 92.6184 473.76 91.0996 473.76C89.5808 473.76 88.3496 474.991 88.3496 476.51C88.3496 478.029 89.5808 479.26 91.0996 479.26Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0996 479.26C85.6184 479.26 86.8496 478.029 86.8496 476.51C86.8496 474.991 85.6184 473.76 84.0996 473.76C82.5808 473.76 81.3496 474.991 81.3496 476.51C81.3496 478.029 82.5808 479.26 84.0996 479.26Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5 481.14L87.1 464.91L68.5 481.14Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5 481.14L87.1 464.91",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5898 464.47L108.95 474.92L86.5898 464.47Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5898 464.47L108.95 474.92",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7803 440.4L87.0203 465L84.7803 440.4Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7803 440.4L87.0203 465",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.83 654.4H135.46V787.92H193.83V654.4Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.28 621.34V789H194.92L195.16 606.99",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.28 621.34V789H194.92L195.16 606.99",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.28 621.34V789H194.92L195.16 606.99",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.28 621.34V789H194.92L195.16 606.99",
    stroke: "#F7F9F9",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.06 623.79L205.4 605.12",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.06 623.79L205.4 605.12",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.75 782.25L81.5801 778.47L134.51 775.39",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.75 782.25L81.5801 778.47L134.51 775.39",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.75 782.25L81.5801 778.47L134.51 775.39",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.75 782.25L81.5801 778.47L134.51 775.39",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.75 764.35L81.3398 761.27L134.51 757.49",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.75 764.35L81.3398 761.27L134.51 757.49",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.75 764.35L81.3398 761.27L134.51 757.49",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.75 764.35L81.3398 761.27L134.51 757.49",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.54 756.37L246.29 760.62L194.5 764.64",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.54 756.37L246.29 760.62L194.5 764.64",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.54 756.37L246.29 760.62L194.5 764.64",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.54 756.37L246.29 760.62L194.5 764.64",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.89 774.63L246.41 779.83L194.69 783.14",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.89 774.63L246.41 779.83L194.69 783.14",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.89 774.63L246.41 779.83L194.69 783.14",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.89 774.63L246.41 779.83L194.69 783.14",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.16 612.75V519.17H193.53V599.73",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.16 612.75V519.17H193.53V599.73",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.16 612.75V519.17H193.53V599.73",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.16 612.75V519.17H193.53V599.73",
    stroke: "#F7F9F9",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.41 520.1L134.33 537.77L193.08 528.29V519.93L134.41 520.1Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.41 520.1L134.33 537.77L193.08 528.29V519.93L134.41 520.1Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.52 553.55V536.89L183.43 530.42V547.35L144.52 553.55Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.52 553.55V536.89L183.43 530.42V547.35L144.52 553.55Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.43 546.75V601.82",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.43 546.75V601.82",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.76 614.74L204.16 596.55",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.76 614.74L204.16 596.55",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.52 553.55V610.03",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.52 553.55V610.03",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.642 666.398L135.451 787.838L193.611 787.929L193.802 666.489L135.642 666.398Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.96 615.45V778.88H174.57L174.39 612.75",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.96 615.45V778.88H174.57L174.39 612.75",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.55 710.42H158.79V726.02H171.55V710.42Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.55 710.42H158.79V726.02H171.55V710.42Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.79 692.42H169.55V701.9C169.55 702.327 169.699 702.74 169.97 703.07L171.13 704.48C171.402 704.809 171.55 705.223 171.55 705.65V708H158.79V705.63C158.79 705.203 158.939 704.789 159.21 704.46L160.37 703.05C160.642 702.72 160.79 702.307 160.79 701.88V692.42Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.54 690.42H170.9C171.261 690.404 171.614 690.529 171.883 690.771C172.153 691.012 172.316 691.349 172.34 691.71C172.316 692.071 172.153 692.408 171.883 692.649C171.614 692.891 171.261 693.016 170.9 693H159.54C159.178 693.016 158.825 692.891 158.556 692.649C158.287 692.408 158.123 692.071 158.1 691.71C158.123 691.349 158.287 691.012 158.556 690.771C158.825 690.529 159.178 690.404 159.54 690.42Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.64 728.79H158.88V744.39H171.64V728.79Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.64 728.79H158.88V744.39H171.64V728.79Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.64 746.87H158.88V751.85H171.64V746.87Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.64 746.87H158.88V751.85H171.64V746.87Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.88 758.86V753.88H171.64V758.86L168.39 760.28H165.91L164.14 761.69L162.01 759.57L158.88 758.86Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.88 758.86V753.88H171.64V758.86L168.39 760.28H165.91L164.14 761.69L162.01 759.57L158.88 758.86Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.14 761.69L158.88 764.64L170.28 767.44L158.88 769.92L170.28 772.05L159.5 774.63",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.14 761.69L158.88 764.64L170.28 767.44L158.88 769.92L170.28 772.05L159.5 774.63",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.14 761.69L158.88 764.64L170.28 767.44L158.88 769.92L170.28 772.05L159.5 774.63",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.14 761.69L158.88 764.64L170.28 767.44L158.88 769.92L170.28 772.05L159.5 774.63",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.28 775.32H160.24V778.82H170.28V775.32Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.28 775.32H160.24V778.82H170.28V775.32Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.93 774.61H159.59V776.03H170.93V774.61Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.93 774.61H159.59V776.03H170.93V774.61Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.02 458H487.02V473H493.02V458Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3058_90418"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 854,
    height: 790,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3058_90418"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 907.03,
    height: 663.5,
    fill: "white",
    transform: "translate(-26 127)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiWellPlungerLift);
export default __webpack_public_path__ + "static/media/multi-well-plunger-lift.d3f64ecf0c5412f9455e53a59b4c77e7.svg";
export { ForwardRef as ReactComponent };